enum SHOP_CATEGORY {
  RESTAURANT = 'restaurant',
  CAFE = 'cafe',
  LIFE = 'life',
  FRUITES = 'fruits',
  DAILY_GOODS = 'daily_goods',
  FOOD = 'food',
  HYGIENE = 'hygiene',
  KITCHEN_WARE = 'kitchen_ware',
  VISIT = 'visit',
}

export default SHOP_CATEGORY;
